import React, { useEffect } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import {
  change,
  Field,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import {
  CheckboxField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import ImageEditor from "components/ImageEditor"
import {
  getPlacesMenuItem,
  getSurvey,
  resetPlacesMenuItem,
  updatePlacesForm,
} from "store/actions"
import validate from "./placesValidation"
import { SaveButton } from "components/Buttons"
import { mapApiResponseToPlacesForm, mapPlacesFormToApi } from "../utils"
import PropTypes from "prop-types"
import LocationAutocomplete from "./locationAutocomplete"
import { LoadingIndicator } from "components/LoadingIndicator"

let Places = props => {
  useEffect(() => {
    props.getPlacesMenuItem({
      vendor_id: props.vendorId,
      dashboard: "",
      menu_item_id: props.feature.id,
    })
    props.getSurvey({
      vendor_id: props.vendorId,
      all: true,
      is_for_places: true,
      ...(!!props.selectedEvent ? { event_id: props.selectedEvent.id } : {}),
    })
    return () => {
      props.resetPlacesMenuItem()
    }
  }, [])

  useEffect(() => {
    if (props.placesMenuItem && Object.keys(props.placesMenuItem).length > 0) {
      props.initializeForm({
        places_form: mapApiResponseToPlacesForm(props.placesMenuItem),
      })
    }
  }, [props.placesMenuItem])

  const handleSubmit = data => {
    props.updatePlacesForm(
      mapPlacesFormToApi({
        ...data.places_form,
        vendorId: props.vendorId,
        menu_item_id: props.feature.id,
      })
    )
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row>
              <Col>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
            {/* <Row className="my-3"> */}
            <Row className="my-1">
              <Col xs={12}>
                <Field
                  name="feedback"
                  component={CheckboxField}
                  label="Provide Feedback"
                />
              </Col>
            </Row>
            {props?.feedback && (
              <Row className="mb-3">
                <Col>
                  <Field
                    name="survey"
                    component={SingleSelectField}
                    options={props.survey.map(x => ({
                      label: x.name,
                      value: x.id,
                    }))}
                    isSearchable={false}
                    label="Select Survey"
                  />
                </Col>
              </Row>
            )}
            <Row className="my-2">
              <Col>
                <Field
                  name="enableMapSearch"
                  component={CheckboxField}
                  label="Enable Google Map Search (Doesn't search Places locations. Only searches Google Maps.)"
                />
              </Col>
            </Row>
            <Row className="my-2">
              <Col>
                <Field
                  name="enableStarRatings"
                  component={CheckboxField}
                  label="Enable Star Ratings"
                />
              </Col>
            </Row>
            {props?.enableStarRatings && (
              <Row className="my-1 ms-2">
                <Col>
                  <Field
                    name="hidePublicRating"
                    component={CheckboxField}
                    label="Hide Public Rating (Ratings will be for internal)"
                  />
                </Col>
              </Row>
            )}
            <Row className="my-2">
              <Col>
                <Field
                  name="enableStarredLocations"
                  component={CheckboxField}
                  label="Enable Starred Locations"
                />
              </Col>
            </Row>
            {props?.enableStarredLocations && (
              <Row className="mb-3 mt-1">
                <Col>
                  <Field
                    name="starredLocationLabel"
                    component={TextField}
                    label="Starred Location Label"
                  />
                </Col>
              </Row>
            )}
            <Row className="my-1">
              <Col>
                <Field
                  name="enableSponsoredBanner"
                  component={CheckboxField}
                  label="Enable Sponsored Banner"
                />
              </Col>
            </Row>
            {props?.enableSponsoredBanner && (
              <div>
                <Row className="my-1">
                  <Col>
                    <Field
                      name="sponsorUrl"
                      component={TextField}
                      label="Sponsor URL"
                    />
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col>
                    <Field
                      name="sponsorBanner"
                      component={ImageEditor}
                      onDelete={() =>
                        props.change("places_form.deleteBanner", true)
                      }
                      label="Sponsor Banner: (300px W x 50px H)"
                    />
                  </Col>
                </Row>
              </div>
            )}
            <Row className="my-2">
              <Col>
                <Field
                  component={TextField}
                  type="number"
                  name="zoomLevel"
                  label="Zoom Level"
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xl={12}>
                <Field
                  name="centerMap"
                  component={CheckboxField}
                  label="Center Map on User Location"
                />
              </Col>
            </Row>
            <Row
              className="my-3"
              style={{
                border: "1px solid silver",
                borderRadius: "15px",
                backgroundColor: "WhiteSmoke",
              }}
            >
              <Row className="mt-4">
                <Col xl={3}>
                  <b>
                    {props.centerMap
                      ? "Back Up Map Center if location services not available"
                      : "Center Map Address:"}
                  </b>
                </Col>
                <Col xl={9}>
                  <Field
                    name="centerMapAddress"
                    component={LocationAutocomplete}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xl={3}>
                  <b>Center Map Latitude:</b>
                </Col>
                <Col xl={9}>
                  <Field
                    name="centerMapLatitude"
                    component="input"
                    type="text"
                    style={{
                      background: "transparent",
                      borderWidth: "0px",
                      outline: "none",
                    }}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row className="my-4">
                <Col xl={3}>
                  <b>Center Map Longitude:</b>
                </Col>
                <Col xl={9}>
                  <Field
                    name="centerMapLongitude"
                    component="input"
                    type="text"
                    style={{
                      background: "transparent",
                      borderWidth: "0px",
                      outline: "none",
                    }}
                    disabled={true}
                  />
                </Col>
              </Row>
            </Row>
            {/* <Row className="my-3">
            <Col>
              <Field name="mapUrl" component={TextField} label="Map URL" />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name="mapKey"
                component={TextField}
                label="Google Maps KEY"
              />
            </Col>
          </Row> */}
            <Row className="my-3">
              <Col xl={12}>
                <Field
                  name="enableNotification"
                  component={CheckboxField}
                  label="Enable Survey Reminder Notification"
                />
              </Col>
            </Row>
            {props?.enableNotification && (
              <div>
                <Row className="my-3 d-flex align-items-center">
                  <Col xs={"auto"}>
                    <span>Send Reminder Notification in</span>
                  </Col>
                  <Col xs={2} className="p-0">
                    <Field
                      name="notificationReminder"
                      component={TextField}
                      type="number"
                      min="0"
                    />
                  </Col>
                  <Col xs="auto">
                    <span>minutes</span>
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="notificationsurvey"
                      component={SingleSelectField}
                      options={props.survey.map(x => ({
                        label: x.name,
                        value: x.id,
                      }))}
                      isSearchable={false}
                      label="Select Survey"
                    />
                  </Col>
                </Row>
              </div>
            )}
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.handleSubmit(handleSubmit)}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

Places = reduxForm({
  form: FORM_NAMES.PLACES,
  initialValues: { places_form: { centerMap: true, zoomLevel: 15 } },
  validate,
})(Places)

const selector = formValueSelector(FORM_NAMES.PLACES)

const mapStateToProps = state => ({
  feedback: selector(state, "places_form.feedback"),
  enableStarRatings: selector(state, "places_form.enableStarRatings"),
  enableStarredLocations: selector(state, "places_form.enableStarredLocations"),
  enableSponsoredBanner: selector(state, "places_form.enableSponsoredBanner"),
  centerMap: selector(state, "places_form.centerMap"),
  enableNotification: selector(state, "places_form.enableNotification"),
  survey: state.Places.survey,
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  placesMenuItem: state.Places.placesMenuItem,
  loading: state.Places.loading,
})

const mapDispatchToProps = dispatch => ({
  getSurvey: values => dispatch(getSurvey(values)),
  updatePlacesForm: values => dispatch(updatePlacesForm(values)),
  change: (field, value) => dispatch(change(FORM_NAMES.PLACES, field, value)),
  getPlacesMenuItem: values => dispatch(getPlacesMenuItem(values)),
  initializeForm: values => dispatch(initialize(FORM_NAMES.PLACES, values)),
  resetPlacesMenuItem: () => dispatch(resetPlacesMenuItem()),
})

Places.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(Places)
